import React from 'react';
import { IconCalendarPlus, IconRoute, IconPigMoney } from '@tabler/icons-react';
const steps = [{
  step: 1,
  icon: <IconCalendarPlus size={22} stroke={1.8} style={{
    color: '#4A7AFF'
  }} data-id="element-12" />,
  title: 'Collega i tuoi check-in',
  description: 'Integra i tuoi calendari di check-in e check-out con CleanAI. Il sistema vede le tue proprietà, dove sono e quando servono interventi — e li incrocia con quelli degli altri host vicini a te.'
}, {
  step: 2,
  icon: <IconRoute size={22} stroke={1.8} style={{
    color: '#4A7AFF'
  }} data-id="element-13" />,
  title: "L'algoritmo raggruppa e ottimizza",
  description: 'CleanAI analizza chi è disponibile e chi è già operativo nella zona, poi raggruppa gli interventi per orario e posizione. Risultato: percorsi ottimizzati, il professionista giusto al momento giusto.'
}, {
  step: 3,
  icon: <IconPigMoney size={22} stroke={1.8} style={{
    color: '#4A7AFF'
  }} data-id="element-14" />,
  title: 'Tu risparmi, la qualità resta alta',
  description: 'Più interventi in sequenza significa meno spostamenti e un costo più basso per ciascuno. Ma la qualità non cala: ogni professionista è monitorato, ogni intervento tracciato con foto e review.'
}];
export function ComeFunzionaSection() {
  return <section className="w-full bg-page-bg py-20 md:py-24 px-5 pt-[40px] pb-[40px]" data-id="element-15">
      <div className="max-w-6xl mx-auto" data-id="element-16">
        {/* Section badge */}
        <div className="flex justify-center mb-4" data-id="element-17">
          <span className="inline-block border rounded-full px-4 py-1 text-xs uppercase font-bold tracking-widest" style={{
          borderColor: '#FF4081',
          color: '#FF4081'
        }} data-id="element-18">
            COME FUNZIONA
          </span>
        </div>

        {/* Heading */}
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-navy text-center" data-id="element-19">
          Tre step veloci, e{' '}
          <span style={{
          color: '#FF4081'
        }} data-id="element-20">
            non ci pensi più.
          </span>
        </h2>

        {/* Pink underline accent */}
        <div className="flex justify-center mt-4" data-id="element-21">
          <div style={{
          width: '40px',
          height: '3px',
          background: '#FF4081',
          borderRadius: '2px'
        }} data-id="element-22" />
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mt-12" data-id="element-23">
          {steps.map(s => <div key={s.step} data-id="element-24">
              {/* Card */}
              <div className="bg-white rounded-none p-7 h-full border-2" style={{
            borderColor: '#FF4081'
          }} data-id="element-25">
                <div className="w-9 h-9 rounded-full flex items-center justify-center mb-4" style={{
              background: '#FF4081'
            }} data-id="element-26">
                  <span className="text-white font-bold text-sm" data-id="element-27">{s.step}</span>
                </div>
                <h3 className="font-heading font-semibold text-lg md:text-xl text-navy mb-3" data-id="element-28">
                  {s.title}
                </h3>
                <p className="font-body text-body-gray text-sm md:text-base leading-relaxed" data-id="element-29">
                  {s.description}
                </p>
              </div>
            </div>)}
        </div>

        {/* Shared callout below cards */}
        <div className="mt-10 max-w-3xl mx-auto rounded-lg py-5 px-8 text-center pt-[10px] pb-[10px]" data-id="element-30">
          <p className="font-body md:text-[15px] text-[16px]" style={{
          color: '#FF4081'
        }} data-id="element-31">
            <span className="inline-block w-2 h-2 rounded-full mr-2 align-middle" style={{
            background: '#FF4081'
          }} data-id="element-32" />
            Paghi meno non perché il servizio vale meno, ma perché il sistema è
            più efficiente. Non ti assegniamo il primo disponibile — ti
            assegniamo quello giusto, che è già lì vicino.
          </p>
        </div>
      </div>
    </section>;
}